<template>
  <div class="table-column-settings">
    <el-button @click="visible = true">列配置</el-button>
    <el-dialog v-model="visible" title="列配置" width="420px" destroy-on-close>
      <div class="column-list">
        <div
          v-for="(column, index) in editableColumns"
          :key="column.key"
          class="column-item"
          draggable="true"
          @dragstart="handleDragStart(index)"
          @dragover.prevent
          @drop="handleDrop(index)"
        >
          <span class="drag-handle">拖拽</span>
          <el-checkbox v-model="column.visible">{{ column.label }}</el-checkbox>
          <div class="sort-actions">
            <el-button link :disabled="index === 0" @click="moveColumn(index, -1)">上移</el-button>
            <el-button link :disabled="index === editableColumns.length - 1" @click="moveColumn(index, 1)">下移</el-button>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="resetColumns">恢复默认</el-button>
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="saveColumns">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { ref, watch } from 'vue'
import { getStoredColumns, saveStoredColumns } from '@/utils/tableColumns'

const props = defineProps({
  tableKey: {
    type: String,
    required: true,
  },
  columns: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['update'])

const visible = ref(false)
const editableColumns = ref([])
const dragIndex = ref(null)

const cloneColumns = (columns) => columns.map(column => ({ ...column }))

const loadColumns = () => {
  const storedColumns = getStoredColumns(props.tableKey, props.columns)
  editableColumns.value = cloneColumns(storedColumns)
  emit('update', cloneColumns(storedColumns))
}

const moveColumn = (index, offset) => {
  const targetIndex = index + offset
  if (targetIndex < 0 || targetIndex >= editableColumns.value.length) {
    return
  }
  const nextColumns = [...editableColumns.value]
  const [column] = nextColumns.splice(index, 1)
  nextColumns.splice(targetIndex, 0, column)
  editableColumns.value = nextColumns
}

const handleDragStart = (index) => {
  dragIndex.value = index
}

const handleDrop = (targetIndex) => {
  if (dragIndex.value === null || dragIndex.value === targetIndex) {
    dragIndex.value = null
    return
  }
  const nextColumns = [...editableColumns.value]
  const [column] = nextColumns.splice(dragIndex.value, 1)
  nextColumns.splice(targetIndex, 0, column)
  editableColumns.value = nextColumns
  dragIndex.value = null
}

const saveColumns = () => {
  saveStoredColumns(props.tableKey, editableColumns.value)
  emit('update', cloneColumns(editableColumns.value))
  visible.value = false
}

const resetColumns = () => {
  editableColumns.value = cloneColumns(props.columns)
}

watch(
  () => props.columns,
  () => loadColumns(),
  { immediate: true, deep: true }
)
</script>

<style scoped lang="less">
.table-column-settings {
  display: inline-flex;
}

.column-list {
  display: grid;
  gap: 8px;
}

.column-item {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) 92px;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  padding: 0 10px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #fff;
}

.drag-handle {
  color: #909399;
  cursor: move;
  font-size: 12px;
}

.sort-actions {
  display: flex;
  justify-content: flex-end;
}
</style>
